module.exports = __webpack_public_path__ + "static/img/wzmacniacz8.110c623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wzmacniacz8.png
// module id = C2Db
// module chunks = 1